export function FolderPickerSkeleton() {
  return (
    <div className="space-y-1 p-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-md px-3 py-2.5">
          <div className="h-5 w-5 animate-pulse rounded bg-accent" />
          <div className="h-4 animate-pulse rounded bg-accent" style={{ width: `${60 + i * 10}%` }} />
        </div>
      ))}
    </div>
  );
}
